import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import {configurationsAPI} from "../../configurations/api/api";
import {addGameNamesToRTPProfiles} from "../../configurations/components/Utils/rtp-profiles";
import {checkPermission} from "../../../utils/Authorization/authorization";

function* getConfigurationsList(action) {
    try {
        const configs = yield call(() =>
            hallsAPI.getConfigurationsList(action.payload.serverId)
        );

        const configurationVersions = [...configs.data.results];
        const latestConfiguration =
            configurationVersions[configurationVersions.length - 1];

        if (
            latestConfiguration &&
            checkPermission("upload_configuration_remotely")
        ) {
            const config = yield call(() =>
                configurationsAPI.getConfiguration({
                    serverId: action.payload.serverId,
                    config: latestConfiguration.id
                })
            );
            const settings = config.data.settings.settings;
            latestConfiguration.game_rtp_profiles = addGameNamesToRTPProfiles(
                settings.game_rtp_profiles !== undefined
                    ? settings.game_rtp_profiles
                    : settings.rtp_profiles,
                settings.game_settings
            );
        }

        yield put({
            type: HallsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS,
            payload: {
                configs: configurationVersions
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting configurations list.");

        yield put({
            type: HallsActionTypes.GET_CONFIGURATIONS_LIST_FAIL,
            message: e.message
        });
    }
}

export function* getConfigurationsListWatcher() {
    yield takeLatest(
        HallsActionTypes.GET_CONFIGURATIONS_LIST,
        getConfigurationsList
    );
}
